// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zFAG","rootMobile":"styles_rootMobile__GvkB5"};